module.exports = __webpack_public_path__ + "static/img_9464-b6d62309cfc9430a67c378aa4c19620b.webp";